import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue";
import _imports_0 from '../assets/imgs/dashboard_query.png';
import _imports_1 from '../assets/imgs/dashboard_owner.svg';
import _imports_2 from '../assets/imgs/dashboard_patrol.png';
import _imports_3 from '../assets/imgs/dashboard_material.png';
import _imports_4 from '../assets/imgs/dashboard_maintenance.png';
const _hoisted_1 = {
  class: "home"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1);

const _hoisted_3 = [_hoisted_2];

const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1);

const _hoisted_5 = [_hoisted_4];

const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}, null, -1);

const _hoisted_7 = [_hoisted_6];

const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3
}, null, -1);

const _hoisted_9 = [_hoisted_8];

const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4
}, null, -1);

const _hoisted_11 = [_hoisted_10];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_area_info = _resolveComponent("area-info");

  const _component_bind_wechat_account = _resolveComponent("bind-wechat-account");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.checkPermission('query', _ctx.permissions) ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "home-action",
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    (...args) => _ctx.jumpToQuery && _ctx.jumpToQuery(...args))
  }, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "home-action",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    (...args) => _ctx.jumpToOwnerAdd && _ctx.jumpToOwnerAdd(...args))
  }, _hoisted_5), _ctx.checkPermission('patrol', _ctx.permissions) ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "home-action",
    onClick: _cache[2] || (_cache[2] = //@ts-ignore
    (...args) => _ctx.jumpToPatrol && _ctx.jumpToPatrol(...args))
  }, _hoisted_7)) : _createCommentVNode("", true), _ctx.checkPermission('material', _ctx.permissions) ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "home-action",
    onClick: _cache[3] || (_cache[3] = //@ts-ignore
    (...args) => _ctx.jumpToMaterial && _ctx.jumpToMaterial(...args))
  }, _hoisted_9)) : _createCommentVNode("", true), _ctx.checkPermission('maintenance', _ctx.permissions) ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "home-action",
    onClick: _cache[4] || (_cache[4] = //@ts-ignore
    (...args) => _ctx.jumpToMaintenance && _ctx.jumpToMaintenance(...args))
  }, _hoisted_11)) : _createCommentVNode("", true), _ctx.hasMultipleAreas ? (_openBlock(), _createBlock(_component_area_info, {
    key: 4
  })) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
    show: _ctx.showBindDialog,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => _ctx.showBindDialog = $event),
    closeable: false,
    round: "",
    "close-on-click-overlay": false
  }, {
    default: _withCtx(() => [_createVNode(_component_bind_wechat_account, {
      "auth-id": _ctx.authId,
      onFinishBind: _ctx.handleFinishBind
    }, null, 8, ["auth-id", "onFinishBind"])]),
    _: 1
  }, 8, ["show"])]);
}